// @flow

import styles from './RelatedSearches.less';

import React from 'react';
import { connect } from 'react-redux';

import qualifyRelatedSearch from '@seek/related-search-seo/dist/qualify-related-search';
import { linkRelForKeyword } from '@seek/related-search-seo/dist/keyword-follow-rules';

import NavLink from 'src/components/NavLink/NavLink';
import { Text, TextLink } from 'seek-style-guide/react';

import { relatedSearchClicked } from 'src/store/results/results';

type Props = {
  filteredSearches: Array<RelatedSearchKeyword>,
  onRelatedSearchClick: mixed => void
};

function RelatedSearches({ filteredSearches, onRelatedSearchClick }: Props) {
  return (
    <div className={styles.root} data-automation="related-searches">
      <Text className={styles.heading} small>
        <h2>Related Searches</h2>
      </Text>
      <ul>
        {filteredSearches.map((relatedSearchKeyword, index) => {
          const { keywords, types } = relatedSearchKeyword;
          return (
            <li className={styles.item} key={keywords}>
              <Text small>
                <NavLink
                  component={TextLink}
                  className={styles.link}
                  location={{
                    pathname: '/jobs',
                    query: qualifyRelatedSearch(relatedSearchKeyword)
                  }}
                  aria-label={`${keywords} jobs`}
                  analytics="related-search-click"
                  rel={linkRelForKeyword(keywords, types)}
                  preNavigationHooks={[onRelatedSearchClick]}
                  data-automation="related-search-link"
                >
                  {`${keywords} jobs`}
                </NavLink>
                {index !== filteredSearches.length - 1 ? (
                  <span>,&nbsp;</span>
                ) : null}
              </Text>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default connect(
  null,
  {
    onRelatedSearchClick: relatedSearchClicked
  }
)(RelatedSearches);
